export default "__VITE_PUBLIC_ASSET__2af183bc__"